/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    a: "a",
    p: "p",
    span: "span"
  }, _provideComponents(), props.components);
  return React.createElement("section", null, React.createElement("p", null, " ", React.createElement("i", null, "The GraphQL Playground has been deprecated."), " You can now use the GraphQL API Explorer. The API Explorer provides a user-friendly interface for testing your GraphQL queries. "), React.createElement("p", null, " You can access the API Explorer at ", React.createElement("a", {
    href: "https://api-gateway.escapia.com/graphql"
  }, " ", React.createElement(_components.a, {
    href: "https://api-gateway.escapia.com/graphql",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "https://api-gateway.escapia.com/graphql"), " "), ". "), React.createElement(_components.p, null, "For authentication, follow the directions in the ", React.createElement(_components.a, {
    href: "/Documentation/Escapia/#authentication"
  }, "Authentication"), " section of the GraphQL API documentation to obtain a token.\n", React.createElement("p", null, " You can use the token to authenticate in the GraphQL Explorer by adding the following header: ")), React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<div class=\"gatsby-highlight\" data-language=\"text-example\"><pre style=\"counter-reset: linenumber NaN\" class=\"language-text-example line-numbers\"><code class=\"language-text-example\">Authorization: Bearer YOUR_TOKEN</code><span aria-hidden=\"true\" class=\"line-numbers-rows\" style=\"white-space: normal; width: auto; left: 0;\"><span></span></span></pre></div>"
    }
  }));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
